import { RhNumberField } from '../../../../../../dum';
import React from 'react';
import { IExpense, REQUIRE_TAX, TAX_RETAINED } from '../expense-form';
import { useCalculateExpenseTotal } from '../use-calculate-expense-total';
import { useSetFirstExpenseResourceItem } from '../use-set-first-expense-resource-item';
import { useCalculateExpenseResourcesTotal } from '../use-calculate-expense-resources-total';
import { useFieldRevert } from '../use-field-revert';
import { RevertHint } from '../revert-hint';
import { useWatch } from 'react-hook-form';
import { FIELD_LABELS, shortLabel } from '../../../../../../../helpers';

export function TaxRetainedInput() {
    const { calculateExpenseTotal } = useCalculateExpenseTotal();
    const { setFirstExpenseResourceItem } = useSetFirstExpenseResourceItem();
    const { calculateExpenseResourcesTotal } =
        useCalculateExpenseResourcesTotal();
    const { original, hasChanged, revert } = useFieldRevert(TAX_RETAINED);
    const requireTax = useWatch({
        name: REQUIRE_TAX,
    }) as IExpense['require_tax'];
    const taxRetained = useWatch({
        name: TAX_RETAINED,
    }) as IExpense['tax_retained'];
    const disableTaxRetained =
        !requireTax && Number(taxRetained) === 0;

    return (
        <RhNumberField
            name={TAX_RETAINED}
            label={shortLabel(FIELD_LABELS.tax_retained)}
            disabled={disableTaxRetained}
            onChange={() => {
                calculateExpenseTotal();
                setFirstExpenseResourceItem();
                calculateExpenseResourcesTotal();
            }}
            helperText={
                <RevertHint
                    hasChanged={!!requireTax && hasChanged}
                    original={original}
                    onRevert={() => {
                        revert();
                        calculateExpenseTotal();
                    }}
                />
            }
        />
    );
}
